import { i18n } from '@/main.js'

let timeline = [
    {
        header: `Ortec - 12 ${i18n.t('about.eoTimeline.month')}`,
        card: {
            title: `"Ortec and the fun of algorithimic programming!\" Powered by Ortec`,
            program: `12 ${i18n.t('about.eoTimeline.month')} - 10:00`,
            link: "https://goo.gl/maps/tdf92wepyHt",
            location: "about.eoTimeline.upbRectorat"
        }
    },
    {
        header: `Stand&Fun program - 14 ${i18n.t('about.eoTimeline.month')}`,
        card: {
            title: "Stand&Fun program",
            program: `14 ${i18n.t('about.eoTimeline.month')} - 10:00`,
            link: "https://goo.gl/maps/43V1wPyh29s",
            location: "about.eoTimeline.bn"
        }
    },
    {
        header: `Main Challenge - 16,17 ${i18n.t('about.eoTimeline.month')}`,
        card: {
            title: "Main Challenge",
            program: `16,17 ${i18n.t('about.eoTimeline.month')} - 10:00`,
            link: "https://goo.gl/maps/Lc5kwNK3eGP2",
            location: "about.eoTimeline.library"
        }
    },
    {
        header: `UiPath - 23 ${i18n.t('about.eoTimeline.month')}`,
        card: {
            title: `"Ignite Your Automation!" Powered by UiPath`,
            program: `23 ${i18n.t("about.eoTimeline.month")} - 10:00`,
            link: "https://goo.gl/maps/sFFCti49GFM2",
            location: "about.eoTimeline.uiPath"
        }
    },
    {
        header: `Enevo - 24 ${i18n.t('about.eoTimeline.month')}`,
        card: {
            title: "Side Challenge Enevo",
            program: `24 ${i18n.t("about.eoTimeline.month")} - 10:00`,
            link: "https://goo.gl/maps/tdf92wepyHt",
            location: "about.eoTimeline.upbRectorat"
        }
    },
    {
        header: `BCR - 26 ${i18n.t('about.eoTimeline.month')}`,
        card: {
            title: `"CodeFest" Powered by BCR`,
            program: `26 ${i18n.t("about.eoTimeline.month")} - 8:00`,
            link: "https://goo.gl/maps/i9hUoLUaSHC2",
            location: "about.eoTimeline.bcr"
        }
    }
]

export default timeline;